import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  standalone: false,
  selector: 'app-login',
  template: "<app-loading-overlay [show]=\"loading\"></app-loading-overlay>\n\n<section class=\"login-page\">\n  <form class=\"login-panel\" (submit)=\"$event.preventDefault(); login();\">\n    <img src=\"/assets/img/LogoScipioneCup.png\" alt=\"Logo ScipioneCup\" />\n    <p class=\"eyebrow\">Area riservata</p>\n    <h2>ScipioneCup Admin</h2>\n\n    <label>\n      Utente\n      <input type=\"text\" [(ngModel)]=\"username\" name=\"username\" autocomplete=\"username\" />\n    </label>\n\n    <label>\n      Password\n      <input type=\"password\" [(ngModel)]=\"password\" name=\"password\" autocomplete=\"current-password\" />\n    </label>\n\n    <button type=\"submit\" [disabled]=\"loading\">{{ loading ? 'Accesso...' : 'Accedi' }}</button>\n    <p class=\"error-message\" *ngIf=\"errorMessage\">{{ errorMessage }}</p>\n  </form>\n</section>\n",
  styles: [".login-page {\n  align-items: center;\n  background:\n    linear-gradient(180deg, rgba(5, 5, 5, 0.78), rgba(5, 5, 5, 0.97)),\n    url('/assets/img/LogoScipioneCup.png') center / min(100vw, 900px) auto no-repeat;\n  display: grid;\n  min-height: 100vh;\n  padding: 1.25rem;\n}\n\n.login-panel {\n  background: linear-gradient(145deg, rgba(18, 22, 18, 0.97), rgba(7, 8, 7, 0.98));\n  border: 1px solid rgba(255, 208, 0, 0.22);\n  border-radius: 22px;\n  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.4);\n  display: grid;\n  gap: 1rem;\n  margin: auto;\n  max-width: 420px;\n  padding: 1.5rem;\n  width: 100%;\n}\n\n.login-panel img {\n  border: 0;\n  border-radius: 14px;\n  height: 112px;\n  object-fit: contain;\n  width: 126px;\n}\n\n.login-panel h2 {\n  color: #fef08a;\n  margin: 0;\n}\n\n.eyebrow {\n  color: #d9f99d;\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  margin: 0;\n  text-transform: uppercase;\n}\n"]
})
export class LoginComponent implements OnInit {
  private readonly authService = new AuthService();
  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly router = inject(Router);

  username = 'admin';
  password = '';
  errorMessage = '';
  loading = true;

  async ngOnInit(): Promise<void> {
    try {
      if (await this.authService.isAuthenticated()) {
        await this.router.navigateByUrl(this.returnUrl());
        return;
      }
    } finally {
      this.loading = false;
      this.changeDetector.detectChanges();
    }
  }

  async login(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';
    this.changeDetector.detectChanges();

    try {
      await this.authService.login(this.username.trim(), this.password);
      await this.router.navigateByUrl(this.returnUrl());
    } catch (error) {
      this.errorMessage = error instanceof Error ? error.message : 'Accesso non riuscito.';
      this.loading = false;
      this.changeDetector.detectChanges();
    }
  }

  private returnUrl(): string {
    return new URLSearchParams(window.location.search).get('returnUrl') || '/admin';
  }
}
